import { useMutation, useQueryClient } from "@tanstack/react-query";
import { serviceMapService } from "../../../services/serviceMapService";
import type { ServiceMap } from "../../../types";

export const useUpdateServiceMap = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceMapId,
      serviceMap,
    }: {
      serviceMapId: string;
      serviceMap: ServiceMap;
    }) => {
      const smi = await serviceMapService.patch(serviceMapId, serviceMap);
      await serviceMapService.updateServiceStatuses(serviceMapId);
      return smi;
    },
    onSuccess: (serviceMapId) => {
      qc.invalidateQueries({ queryKey: ["serviceMapId", serviceMapId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
